export default __webpack_public_path__ + "static/media/pieczatka2.d0f824f4.gif";